'use client'

import { CloseIcon } from '@/components/icons/CloseIcon'
import { Search } from '@/components/shared/search'
import { LanguageSwitcher } from '@/components/ui/language-switcher'
import { SEARCH_DATA } from '@/config/search-data'

import { MobileNavigation } from './mobile-navigation'

interface IMobileMenuProps {
  isOpen: boolean
  onClose: () => void
}

export function MobileMenu({ isOpen, onClose }: IMobileMenuProps) {
  return (
    <div
      className={`absolute top-0 right-0 h-screen w-full bg-gray-50 transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : 'translate-x-full'} `}
    >
      <div className="px-4 py-6">
        <div className="flex justify-end">
          <button
            aria-label="Close mobile menu"
            className="text-body-1 h-10 w-10 text-gray-500 hover:text-gray-700"
            onClick={onClose}
          >
            <CloseIcon size="26px" />
          </button>
        </div>
        <div className="mt-4 h-[40px]">
          <Search onSelect={onClose} options={SEARCH_DATA} />
        </div>
        <div className="mt-10">
          <MobileNavigation onClick={onClose} />
        </div>
        <div className="mt-10">
          <LanguageSwitcher />
        </div>
      </div>
    </div>
  )
}
